import { Button, TextField, Tooltip, InputAdornment } from "@mui/material";
import { ControlPointOutlined, Search } from "@mui/icons-material";
import { useState } from "react";
import BulkCreateAppointment from "../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/BulkCreateAppointment";

const TopMenu = ({ caseInfo, apptSearch, setApptSearch }) => {
  const [openAddAppts, setOpenAddAppts] = useState(false);

  const handleAddAppointment = () => {
    setOpenAddAppts(!openAddAppts);
  };

  return (
    <div className="flex justify-between w-full">
      <div className="xl:h-1/6 w-1/2 mt-4 flex items-center">
        <TextField
          className="w-full mx-4 mr-4 placeholder:text-center rounded-lg"
          placeholder="Search"
          size="small"
          value={apptSearch}
          onChange={(event) => setApptSearch(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="outlined"
          size="medium"
          color="error"
          onClick={() => setApptSearch("")}
          className="w-1/8 mr-4 rounded-md hover:bg-red-500 hover:text-white"
        >
          Reset
        </Button>
      </div>
      <div className="flex items-center">
        <Tooltip title="Add Appointment" placement="left">
          <Button
            className="self-center text-[#32CD30] hover:text-white hover:bg-green-500"
            onClick={handleAddAppointment}
          >
            <span className="mx-4">
              <ControlPointOutlined />
            </span>
          </Button>
        </Tooltip>
      </div>
      {openAddAppts && (
        <BulkCreateAppointment
          open
          onClose={() => setOpenAddAppts(false)}
          title="Create Appointments"
          setOpenAddAppts={setOpenAddAppts}
          caseInfo={caseInfo}
        />
      )}
    </div>
  );
};

export default TopMenu;

